import { Briefcase, Users } from 'lucide-react';

const EXPERIENCES = [
  {
    role: 'Freelance Web Developer',
    company: 'Self-Employed',
    period: 'Jan 2024 – Present',
    icon: Briefcase,
    accent: 'violet',
    responsibilities: [
      'Delivered 10+ client projects end-to-end, from requirements gathering to deployment, using React, Node.js, and modern web tooling',
      'Collaborated directly with clients to translate business needs into working, production-ready applications',
      'Applied SEO best practices and performance optimization to improve load times and user experience',
      'Maintained long-term client relationships through clear communication and post-launch support',
    ],
  },
  {
    role: 'Tech Mentor',
    company: 'Hackerkid — GUVI Geek Network, Chennai',
    period: 'Sep 2024 – Present',
    icon: Users,
    accent: 'pink',
    responsibilities: [
      'Delivered 50+ webinars and 500+ live mentoring sessions to 250+ students aged 7–17',
      'Taught web development, DSA, Gen AI, and Python through hands-on, project-based learning',
      'Guided students through real problem-solving exercises to build practical coding skills',
      'Created engaging learning content tailored to a wide range of skill levels',
    ],
  },
];

const ACCENTS = {
  violet: {
    bar: 'bg-violet-500',
    iconBg: 'bg-violet-50 text-violet-600',
    period: 'text-violet-600',
  },
  pink: {
    bar: 'bg-pink-500',
    iconBg: 'bg-pink-50 text-pink-600',
    period: 'text-pink-600',
  },
};

export default function Experience() {
  return (
    <section id="experience" className="py-24 px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-display font-bold text-4xl sm:text-5xl text-slate-900 mb-4">
          Experience
        </h2>
        <p className="text-slate-500 text-lg max-w-2xl mb-14">
          What I've been doing since I got back to building and teaching.
        </p>

        <div className="space-y-6">
          {EXPERIENCES.map((exp) => {
            const a = ACCENTS[exp.accent];
            return (
              <div
                key={exp.role}
                className="relative flex gap-0 rounded-2xl border border-slate-200 overflow-hidden bg-white hover:shadow-lg hover:shadow-slate-200/60 transition-shadow duration-300"
              >
                <div className={`w-1.5 flex-shrink-0 ${a.bar}`} />

                <div className="p-7 sm:p-9 flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-start gap-5 mb-6">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${a.iconBg}`}>
                      <exp.icon size={22} />
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-xl sm:text-2xl text-slate-900">
                        {exp.role}
                      </h3>
                      <p className="text-slate-500">{exp.company}</p>
                      <p className={`text-sm font-medium mt-1 ${a.period}`}>
                        {exp.period}
                      </p>
                    </div>
                  </div>

                  <ul className="space-y-3">
                    {exp.responsibilities.map((item) => (
                      <li key={item} className="flex items-start gap-3 text-slate-600 leading-relaxed">
                        <span className={`mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0 ${a.bar}`} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}